import { campaignMediaPlanForm, Country, Region } from "@store";
import { FETCH_STATE_FETCHING, FETCH_STATE_SUCCESS } from "rd-redux-http";
import * as React from "react";
import { Fieldset } from "../Fieldset";
import * as cn from "classnames";
import { LoadingSpinner } from "../LoadingSpinner";
import { Triangle } from "@icons";
import * as Autosuggest from "react-autosuggest";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";

import "./GeographicComponent.css";

const suggestionTheme = {
    container: "mySuggestions__container",
    containerOpen: "react-autosuggest__container--open",
    input: "react-autosuggest__input",
    inputOpen: "react-autosuggest__input--open",
    inputFocused: "react-autosuggest__input--focused",
    suggestionsContainer: "",
    suggestionsContainerOpen: "mySuggestions__ContainerOpen",
    suggestionsList: "react-autosuggest__suggestions-list",
    suggestion: "mySuggestions__suggestion",
    suggestionHighlighted: "mySuggestions__suggestionHighlighted",
    sectionContainer: "react-autosuggest__section-container"
};

export interface GeographicComponentProps {
    form: typeof campaignMediaPlanForm.types.selectorResult;
    events: typeof campaignMediaPlanForm.types.eventBindings;
    countryList: Country[];
    zipList: string[];
    placeList: string[];
    onInputSearch: (query: { zip?: string; place?: string }, type: "strict" | "normal", region: string) => void;
    handleAutocompleteInput: (e: any, helper?: { name: string; value: string }) => void;
    placeAndZipFetchState: string;
}

export interface GeographicComponentState {
    noneLoadingFlag: "city" | "zip" | "empty";
}

export class GeographicComponent extends React.Component<GeographicComponentProps, GeographicComponentState> {
    constructor(props: GeographicComponentProps) {
        super(props);
        this.state = {
            noneLoadingFlag: "empty"
        };
        this.handleCgangenoneLoadingFlag = this.handleCgangenoneLoadingFlag.bind(this);
    }

    componentDidUpdate(prevProps: GeographicComponentProps) {
        if (
            prevProps.placeAndZipFetchState === FETCH_STATE_FETCHING &&
            this.props.placeAndZipFetchState === FETCH_STATE_SUCCESS &&
            this.state.noneLoadingFlag !== "empty"
        ) {
            this.setState({
                ...this.state,
                noneLoadingFlag: "empty"
            });
        }
    }

    handleCgangenoneLoadingFlag(value: "city" | "zip" | "empty") {
        this.setState({
            ...this.state,
            noneLoadingFlag: value
        });
    }

    renderCountryList = () => {
        const { countryList } = this.props;
        return countryList.map((item: Country, index: number) => {
            return (
                <option key={`country-${index}`} value={item.iso}>
                    {item.name}
                </option>
            );
        });
    };

    renderRegions = (selectedCountry: string) => {
        const { countryList } = this.props;
        const matchCountry = countryList.find((item, index) => item.iso == selectedCountry);
        return matchCountry
            ? matchCountry.regions.map((item: Region, index: number) => {
                  return (
                      <option key={`region-${index}`} value={item.iso}>
                          {item.name}
                      </option>
                  );
              })
            : null;
    };
    renderSuggestion = (suggestion: any) => {
        return <div>{suggestion}</div>;
    };

    handleRegionChange = async (e: any, val: string) => {
        const { events, handleAutocompleteInput } = this.props;
        await events.fields.region.onChange(e.target.value);
        await events.fields.city.onChange("");
        await events.fields.zipCode.onChange("");
        await handleAutocompleteInput(e, { name: "city", value: "" });
    };

    render() {
        const {
            form,
            events,
            countryList,
            handleAutocompleteInput,
            zipList,
            placeList,
            placeAndZipFetchState
        } = this.props;
        const { noneLoadingFlag } = this.state;

        const selectedCountry = form.fields.country.value;
        const selectedRegion = form.fields.region.value;

        const isLoading: boolean = placeAndZipFetchState === FETCH_STATE_FETCHING;

        return (
            <div className="targeting-item-select-wrapper">
                <Fieldset
                    label="Country"
                    errorMessage={form.fields.country}
                    isMandatory={true}
                    icon={Triangle}
                    svgClassName="svg-triangle"
                >
                    <select
                        className="common-select"
                        name="country"
                        id=""
                        value={form.fields.country.value || ""}
                        {...events.fields.country}
                        onChange={val => {
                            events.fields.country.onChange(val);
                            events.fields.region.onChange("");
                            events.fields.city.onChange("");
                            events.fields.zipCode.onChange("");
                        }}
                    >
                        <option value="">Select country</option>
                        {countryList && this.renderCountryList()}
                    </select>
                </Fieldset>
                <Fieldset
                    className={cn(selectedCountry ? "" : "disabled-custom-geographic-fieldset")}
                    label="Region"
                    errorMessage={form.fields.region}
                    icon={Triangle}
                    svgClassName="svg-triangle"
                >
                    <select
                        className="common-select"
                        name="region"
                        id=""
                        value={form.fields.region.value || ""}
                        {...events.fields.region}
                        {...(selectedCountry ? {} : { disabled: true })}
                        onChange={this.handleRegionChange}
                    >
                        <option value="">Select region</option>
                        {countryList && this.renderRegions(selectedCountry)}
                    </select>
                </Fieldset>
                <div className="geogrphic-premium-block-wrapper">
                    <div className="fieldset-wrapper">
                        <Fieldset
                            className={cn(
                                "fix-index-fieldset",
                                isLoading ? "custom-geographic-fieldset" : "",
                                selectedCountry && selectedRegion ? "" : "disabled-custom-geographic-fieldset"
                            )}
                            label="City"
                            errorMessage={form.fields.city}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <Autosuggest
                                suggestions={placeList}
                                renderSuggestion={this.renderSuggestion}
                                getSuggestionValue={(item: any) => item.place}
                                onSuggestionSelected={(event, { suggestion }) => {
                                    this.handleCgangenoneLoadingFlag("city");
                                    events.fields.city.onChange(suggestion);
                                    handleAutocompleteInput({ target: { name: "city", value: suggestion } });
                                }}
                                onSuggestionsFetchRequested={({ value, reason }) => {
                                    if (reason === "input-changed" || reason === "suggestion-selected")
                                        handleAutocompleteInput({ target: { name: "city", value: value } });
                                }}
                                onSuggestionsClearRequested={() => null}
                                inputProps={{
                                    placeholder: "Type a city",
                                    value: form.fields.city.value || "",
                                    onChange: (e, { newValue }) => events.fields.city.onChange(newValue),
                                    disabled: selectedRegion ? false : true
                                }}
                                theme={suggestionTheme}
                                shouldRenderSuggestions={() => (noneLoadingFlag !== "city" ? true : false)}
                                id="city-suggestion"
                                focusInputOnSuggestionClick={false}
                            />
                        </Fieldset>
                        {isLoading && noneLoadingFlag !== "city" && <LoadingSpinner className="geographic-spinner" />}
                    </div>
                    <PremiumFeatureIcon className="custom-geogrphic-premium-icon" status="trial" />
                </div>
                <div className="geogrphic-premium-block-wrapper">
                    <div className="fieldset-wrapper">
                        <Fieldset
                            className={cn(
                                isLoading ? "custom-geographic-fieldset" : "",
                                selectedCountry && selectedRegion ? "" : "disabled-custom-geographic-fieldset"
                            )}
                            label="Zip-Code"
                            errorMessage={form.fields.zipCode}
                            icon={Triangle}
                            svgClassName="svg-triangle"
                        >
                            <Autosuggest
                                suggestions={zipList}
                                renderSuggestion={this.renderSuggestion}
                                getSuggestionValue={(item: any) => item}
                                onSuggestionSelected={(event, { suggestion }) => {
                                    this.handleCgangenoneLoadingFlag("zip");
                                    events.fields.zipCode.onChange(suggestion);
                                    handleAutocompleteInput({ target: { name: "zipCode", value: suggestion } });
                                }}
                                onSuggestionsFetchRequested={({ value, reason }) => {
                                    if (reason === "input-changed" || reason === "suggestion-selected")
                                        handleAutocompleteInput({ target: { name: "zipCode", value: value } });
                                }}
                                onSuggestionsClearRequested={() => null}
                                inputProps={{
                                    placeholder: "Type a zip-code",
                                    value: form.fields.zipCode.value || "",
                                    onChange: (e, { newValue, method }) => events.fields.zipCode.onChange(newValue),
                                    disabled: selectedRegion ? false : true
                                }}
                                theme={suggestionTheme}
                                shouldRenderSuggestions={() => (noneLoadingFlag !== "zip" ? true : false)}
                                id="zipCode-suggestion"
                                focusInputOnSuggestionClick={false}
                            />
                        </Fieldset>
                        {isLoading && noneLoadingFlag !== "zip" && <LoadingSpinner className="geographic-spinner" />}
                    </div>
                    <PremiumFeatureIcon className="custom-geogrphic-premium-icon" status="trial" />
                </div>
            </div>
        );
    }
}
